import { useApi } from '@/composables/useApi'

const api = useApi()

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchModulos() {
      return new Promise((resolve, reject) => {
        api.get('/getModulo')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchModulosConteudo() {
      return new Promise((resolve, reject) => {
        api.get('/getModuloConteudo')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchModulo(ctx, { id }) {
      return new Promise((resolve, reject) => {
        api.get(`/usuarioAdmin/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addModulo(ctx, moduloData) {
      return new Promise((resolve, reject) => {
        api.post('/createModulo', moduloData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteModulo(ctx, moduloId) {
      return new Promise((resolve, reject) => {
        api.delete(`/deleteModulo/${moduloId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
